import { create } from 'zustand';

const SIDEBAR_STATE_KEY = 'sidebarState';

export interface UiStore {
  sidebarState: boolean;
  topUserMenu: boolean;
  bottomUserMenu: boolean;
  setSidebarState: (state: boolean) => void;
  setUserMenu: (type: 'top' | 'bottom', state: boolean) => void;
  toggleSidebar: () => void;
}

const getDefaultSidebarState = (): boolean => {
  const storedState = localStorage.getItem(SIDEBAR_STATE_KEY);
  return storedState === 'closed' ? false : true;
};
const setDefaultSidebarState = (state: boolean): void => {
  localStorage.setItem(SIDEBAR_STATE_KEY, state ? 'opened' : 'closed');
};

export const useUiStore = create<UiStore>((set) => ({
  topUserMenu: false,
  bottomUserMenu: false,
  sidebarState: getDefaultSidebarState(),
  setSidebarState: (state: boolean) =>
    set(() => {
      setDefaultSidebarState(state);
      return { sidebarState: state };
    }),
  toggleSidebar: () =>
    set((state) => {
      setDefaultSidebarState(!state.sidebarState);
      return { sidebarState: !state.sidebarState };
    }),
  setUserMenu: (type: 'top' | 'bottom', newState: boolean) =>
    set(() => {
      if (type === 'top') {
        return { topUserMenu: newState };
      }
      return { bottomUserMenu: newState };
    }),
}));
